import styled from 'styled-components';

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: fit-content;
`;

export const AreaSupplier = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  overflow-y: auto;
  flex: 1;
`;

export const AreaFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const AreaFooterReject = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.grayLight};
`;

export const AreaReason = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1rem;
`;

export const AreaButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.4rem;

  & .MuiButtonBase-root {
    margin-left: 0px;
    padding: 8px 25px !important;
  }
`;

export const SupplierContainer = styled.div`
  background: ${({ theme }) => theme.grayLight};
  border-radius: 4px;
  padding: 0.1rem;
  margin-bottom: 0.5rem;
`;

export const HeaderSupplier = styled.div`
  display: grid;
  grid-template-columns: 1fr 40px;
  gap: 0.4rem;
  cursor: pointer;
  padding: 0.5rem;
  padding-top: 0;
  align-items: center;
`;

export const TitleSupplier = styled.h5`
  font-weight: bold;
  font-size: 1rem;
  margin: 0;
`;

export const BodySupplier = styled.div``;

export const ItemContainer = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 40px 40px;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: background-color 0.3s;
  padding: 0.5rem;

  &:hover {
    background-color: ${({ theme }) => theme.hoverGray};
  }

  > img {
    width: 100%;
    max-width: 60px;
    max-height: 60px;
    min-width: 60px;
    min-height: 60px;
    object-fit: contain;
  }
`;

export const AreaTitlePart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  overflow: hidden;
`;

export const Quantity = styled.div`
  border: 1px solid ${({ theme }) => theme.pantone2726C};
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20%;
  margin: 0 auto;
`;
